import React from 'react';
import NoticeBoard from '../components/NoticeBoard'; // Re-using your existing component
import Footer from '../components/Footer';

const Notices = () => {
  return (
    <div className="d-flex flex-column min-vh-100">
      
      {/* Simple Header */}
      <div className="bg-success text-white py-5 text-center">
        <div className="container">
          <h1 className="display-4 fw-bold">Notice Board</h1>
          <p className="lead">Stay updated with the latest news from Darul Uloom</p>
        </div>
      </div>

      {/* The Full Board Component */}
      <div className="container my-5 flex-grow-1">
        <NoticeBoard />
      </div>

      <Footer />
    </div>
  );
};

export default Notices;